import React from 'react';
import { DESIGN_THEMES, isDesignSwitcherEnabled } from '../design/themeConfig';
import { useDesignTheme } from '../design/DesignThemeContext';

const OPTIONS = [
  { id: DESIGN_THEMES.LEGACY, label: 'Legacy', hint: 'Current production look' },
  { id: DESIGN_THEMES.CORRIDOR, label: 'Corridor Ledger', hint: 'Murray Road redesign' },
];

export default function DesignThemeSwitcher() {
  const { theme, setTheme } = useDesignTheme();

  if (!isDesignSwitcherEnabled()) {
    return null;
  }

  return (
    <div
      className="fixed bottom-4 left-4 z-[9999] max-w-[15rem] rounded-lg border border-gray-300 bg-white/95 p-3 shadow-lg backdrop-blur-sm"
      role="region"
      aria-label="Design theme preview"
      data-testid="design-theme-switcher"
    >
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Design preview
      </p>
      <div className="space-y-1">
        {OPTIONS.map(option => (
          <label
            key={option.id}
            className={`flex cursor-pointer items-start gap-2 rounded-md px-2 py-1.5 text-sm transition-colors ${
              theme === option.id ? 'bg-blue-50 text-blue-900' : 'hover:bg-gray-50'
            }`}
          >
            <input
              type="radio"
              name="design-theme"
              value={option.id}
              checked={theme === option.id}
              onChange={() => setTheme(option.id)}
              className="mt-0.5"
            />
            <span>
              <span className="block font-medium">{option.label}</span>
              <span className="block text-xs text-gray-500">{option.hint}</span>
            </span>
          </label>
        ))}
      </div>
      <p className="mt-2 border-t border-gray-200 pt-2 text-[0.65rem] leading-snug text-gray-500">
        Saved in this browser. URL override:{' '}
        <code className="rounded bg-gray-100 px-1">?design=corridor</code>
      </p>
    </div>
  );
}
